import './spinner.css'

const Spinner = () => {
    return (
        <div className="loading-spinner-container">
            <div className="loading-spinner"></div>
        </div>
    )
}

export default Spinner;